import React, { FC, InputHTMLAttributes, useId } from 'react'

import * as SC from './styled'

export type ToggleButtonProps = InputHTMLAttributes<HTMLInputElement> & {
  className?: string
  label?: string
  checked?: boolean
  children?: React.ReactElement
}

const ToggleButton: FC<ToggleButtonProps> = ({
  className,
  label,
  children,
  disabled,
  ...checkbox
}) => {
  const uniqueId = useId()

  return (
    <SC.Wrapper
      className={className}
      htmlFor={uniqueId}
      $checked={checkbox.checked}
      $disabled={disabled}
    >
      <SC.Checkbox id={uniqueId} disabled={disabled} {...checkbox} />
      {label && (
        <SC.Label $checked={checkbox.checked} $disabled={disabled}>
          {label}
        </SC.Label>
      )}
      {children}
    </SC.Wrapper>
  )
}

export default ToggleButton
